import * as ActionTypes from './index';
import {actionCreator} from "../helpers/functions";

export const getCampaigns = actionCreator(ActionTypes.GET_CAMPAIGNS);
export const getCampaignsSuccess = actionCreator(ActionTypes.GET_CAMPAIGNS_SUCCESS);
export const getCampaignsFailed = actionCreator(ActionTypes.GET_CAMPAIGNS_FAILED);
export const countCampaigns = actionCreator(ActionTypes.COUNT_CAMPAIGNS);
export const countCampaignsSuccess = actionCreator(ActionTypes.COUNT_CAMPAIGNS_SUCCESS);
export const countCampaignsFailed = actionCreator(ActionTypes.COUNT_CAMPAIGNS_FAILED);
export const changeCampaignPreferences = actionCreator(ActionTypes.CHANGE_CAMPAIGNS_PREFERENCES);
export const changeCampaignsOrder = actionCreator(ActionTypes.CHANGE_CAMPAIGNS_ORDER);
export const createCampaign = actionCreator(ActionTypes.CREATE_CAMPAIGN);
export const createCampaignSuccess = actionCreator(ActionTypes.CREATE_CAMPAIGN_SUCCESS);
export const createCampaignFailed = actionCreator(ActionTypes.CREATE_CAMPAIGN_FAILED);
export const deleteCampaign = actionCreator(ActionTypes.DELETE_CAMPAIGN);
export const editCampaign = actionCreator(ActionTypes.EDIT_CAMPAIGN);
export const editCampaignSuccess = actionCreator(ActionTypes.EDIT_CAMPAIGN_SUCCESS);
export const editCampaignFailed = actionCreator(ActionTypes.EDIT_CAMPAIGN_FAILED);
export const editCampaignField = actionCreator(ActionTypes.EDIT_CAMPAIGN_FIELD);
export const copyCampaignForEdit = actionCreator(ActionTypes.COPY_CAMPAIGN_FOR_EDIT);
export const clearProductCampaignDeleteErrorMessage = actionCreator(ActionTypes.CLEAR_CAMPAIGN_DELETE_ERROR_MESSAGE);
export const deleteCampaignSuccess = actionCreator(ActionTypes.DELETE_CAMPAIGN_SUCCESS);
export const deleteCampaignFailed = actionCreator(ActionTypes.DELETE_CAMPAIGN_FAILED);
export const clearCampaignsForm = actionCreator(ActionTypes.CLEAR_CAMPAIGNS_FORM);
export const clearTempUploadedCampaign = actionCreator(ActionTypes.CLEAR_TEMP_UPLOADED_CAMPAIGN);
export const storeTemporaryCampaignImage = actionCreator(ActionTypes.STORE_TEMPORARY_CAMPAIGN_IMAGE);



// WEBPACK FOOTER //
// ./src/actions/campaigns.js